import React, { useState } from "react";
import "../../assets/css/banner-mundial.css";
import logoMundial from "../../assets/02_Assets/World Cup-white.webp";
import image1 from "../../assets/02_Assets/image1.jpg";
import image2 from "../../assets/02_Assets/image2.webp";
import image3 from "../../assets/02_Assets/image3.webp";
import GaleriaModalMundialComponent from "./galeria-modal-mundial.component";

interface BannerMundialComponentProps {
  multicotizadorData?: any;
}

const BannerMundialComponent: React.FC<BannerMundialComponentProps> = ({ multicotizadorData }) => {
  const [selectedGalery, setSelectedGalery] = useState<number | null>(null);

  const galeriaData = {
    media: [image1, image2, image3],
    mediaType: ["image", "image", "image"]
  };
  return (
    <section className="mundial-hero">
      <div className="mundial-hero-bg"></div>
      
      <div className="mundial-hero-container">
        <div className="mundial-hero-logo">
          <img src={logoMundial} alt="Hyundai Official Partner - FIFA World Cup 2026" />
        </div>

        <div className="mundial-hero-content-row">
          <div className="mundial-hero-left">
            <h1 className="mundial-hero-title">
            Estás a un Hyundai<br/>
            de la Copa Mundial<br/>
            de la FIFA 2026™
          </h1>
          
          <button 
            className="mundial-hero-btn"
            onClick={() => {
              const element = document.getElementById("cotizacion");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            ¡Quiero agendar el Test drive e ir al mundial!
          </button>
        </div>

        <div className="mundial-hero-right">
          <div className="mundial-img-tall" onClick={() => setSelectedGalery(0)} style={{ cursor: "pointer" }}>
            {/* Foto alta */}
            <img src={image1} alt="Mundial Hyundai" />
          </div>
          
          <div className="mundial-img-short" onClick={() => setSelectedGalery(1)} style={{ cursor: "pointer" }}>
            {/* Foto horizonte 1 */}
            <img src={image2} alt="Mundial Hyundai" />
          </div>
          
          <div className="mundial-img-short" onClick={() => setSelectedGalery(2)} style={{ cursor: "pointer" }}>
            {/* Foto horizonte 2 */}
            <img src={image3} alt="Mundial Hyundai" />
          </div>
        </div>
      </div>
      </div>
      
      <GaleriaModalMundialComponent 
        selectedGalery={selectedGalery}
        setSelectedGalery={setSelectedGalery}
        galeria={galeriaData}
      />
    </section>
  );
};

export default BannerMundialComponent;
